export const PUBLIC_MODE_URL =
  "https://anymate-us.oss-us-west-1.aliyuncs.com/common/chat_mode_selection/public.jpg";
export const PRIVATE_MODE_URL =
  "https://anymate-us.oss-us-west-1.aliyuncs.com/common/chat_mode_selection/private.jpg";
export const MIN_POWER_CUBE_LIMIT = 1;
export const MIN_CRYSTAL_LIMIT = 0.5;
/** 未登录-N条消息后触发登录 */
export const MAX_MESSAGE_COUNT = 6;
